import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'Score' })({
    json: {
        padding: '12px 12px 12px 0',
        borderRadius: 18,
        marginTop: 20,
        fontSize: 14,
        minWidth: 130,
        borderColor: '#EEEEEE'
    }
});
